import 'babel-polyfill'
import promise from 'es6-promise'
promise.polyfill()
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
/*import qs from 'Qs'*/
import { parseTime, resetForm, addDateRange, selectDictLabel, download, handleTree } from "@/utils/ruoyi";
import Pagination from "@/components/Pagination/index";
import 'element-ui/lib/theme-chalk/index.css'

import Element from 'element-ui'
Vue.use(Element)

Vue.config.productionTip = false;
/*Vue.prototype.qs = qs;*/
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.download = download
Vue.prototype.handleTree = handleTree

// 全局组件挂载
Vue.component('Pagination', Pagination)

Vue.prototype.message = function (msg, type = 'warning') {
  this.$message({ showClose: true, message: msg, type });
}



router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面meta */
  if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content;
    head[0].appendChild(meta);
  }
  // /* 路由发生变化修改页面title */  
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    /*document.title = '吾征AI'*/
  }
  next()
});

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js